import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { getPrefecture } from '../../../define/const';
import { propShape, propStr } from '../../../helpers/custom-prop-types';
import AddressFieldsAndLabel from './Hook/AddressFieldsAndLabel';
import ZipCodeFields from './Hook/ZipCodeFields';
const ProfessionalAddressFieldsAndLabel = (props) => {
    const { address1, address2, address3, formName, prefecture, zipCode1, zipCode2, } = props;
    const selector = useMemo(() => formValueSelector(formName), [formName]);
    const organization = useSelector((state) => selector(state, 'organization'));
    const [isOpen, changeIsOpen] = useState(false);
    const toggleOpen = useCallback(() => {
        changeIsOpen((prevState) => !prevState);
    }, [changeIsOpen]);
    const organizationAddr = useMemo(() => {
        const { address1: address1Value, address2: address2Value, address3: address3Value, prefecture: prefectureValue, zipCode1: zipCode1Value, zipCode2: zipCode2Value, } = organization || {};
        const memoOrganizationAddr = [];
        if (zipCode1Value && zipCode2Value) {
            memoOrganizationAddr.push(`〒${zipCode1Value}-${zipCode2Value}`);
        }
        const prefectureStr = getPrefecture(prefectureValue);
        if (prefectureStr) {
            memoOrganizationAddr.push(prefectureStr);
        }
        if (address1Value) {
            memoOrganizationAddr.push(address1Value);
        }
        if (address2Value) {
            memoOrganizationAddr.push(address2Value);
        }
        if (address3Value) {
            memoOrganizationAddr.push(address3Value);
        }
        return memoOrganizationAddr.join(' ');
    }, [organization]);
    return (_jsxs("div", Object.assign({ className: 'form form-solution cf' }, { children: [_jsx("h3", { children: "\u4F1A\u793E\u4F4F\u6240" }), _jsx("input", { className: 'input-form-text', disabled: true, type: 'text', value: organizationAddr }), _jsx("div", Object.assign({ className: 'btn-more', onClick: toggleOpen, role: 'presentation' }, { children: _jsx("div", Object.assign({ className: 'link-text fs-14' }, { children: "\u672C\u793E\u3068\u4F4F\u6240\u304C\u7570\u306A\u308B\u5834\u5408" })) })), isOpen && (_jsxs("div", Object.assign({ className: 'more sub-address' }, { children: [_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx("h3", { children: "\u90F5\u4FBF\u756A\u53F7" }), _jsx(ZipCodeFields, { zipCode1: zipCode1, zipCode2: zipCode2 })] })), _jsx(AddressFieldsAndLabel, { address1: address1, address2: address2, address3: address3, prefecture: prefecture, wrapperClassName: 'form form-solution' })] })))] })));
};
ProfessionalAddressFieldsAndLabel.propTypes = {
    address1: propShape().isRequired,
    address2: propShape().isRequired,
    address3: propShape().isRequired,
    formName: propStr().isRequired,
    prefecture: propShape().isRequired,
    zipCode1: propShape().isRequired,
    zipCode2: propShape().isRequired,
};
export default ProfessionalAddressFieldsAndLabel;
